import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Page from 'flow/components/Setting/Page';
import RouteLink from 'flow/components/ui-components/RouteLink';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectHasReturnBlindTransferFeature } from 'flow/selectors/own-extension-selectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { isTeamsTypeIntegration } from 'flow/utils/app-utils';
import { generatePath } from 'flow/utils/router-utils';

const AdvancedTelephony = () => {
    const { i18next } = useAppContext();
    const history = useHistory();

    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    const hasReturnBlindTransferFeature = useAppSelector(
        selectHasReturnBlindTransferFeature,
    );

    const hasCallWidgetFeature = useAppSelector((state) => !!state.callWidgets);
    const hasVersion1 = useAppSelector((state) =>
        state.callWidgets
            ? state.callWidgets.some(
                  (callWidget) => callWidget.get('version') === '1',
              )
            : false,
    );
    const embedded = useAppSelector((state) => state.app.get('embedded'));
    const isTeamsFlowUC = isTeamsTypeIntegration(embedded);

    return (
        <Page
            header="settings.callrouting"
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.softphone'], {
                        extensionKey,
                    }),
                )
            }
        >
            <RouteLink to={routes['settings.softphone.advanced.callrouting']}>
                {i18next.t('settings.callrouting.title')}
            </RouteLink>

            {hasCallWidgetFeature && !isTeamsFlowUC && hasVersion1 ? (
                <RouteLink
                    to={routes['settings.softphone.advanced.callwidgets']}
                >
                    {i18next.t('settings.callrouting.call_widgets')}
                </RouteLink>
            ) : null}

            {hasReturnBlindTransferFeature ? (
                <RouteLink
                    to={routes['settings.softphone.advanced.blind-transfer']}
                >
                    {i18next.t(
                        'settings.callrouting.call_return.blind_transfer',
                    )}
                </RouteLink>
            ) : null}
        </Page>
    );
};

export default AdvancedTelephony;
